import { Popover } from "@base-ui-components/react";

export namespace PopoverPopup {
	export type ElementName = "Popover.Popup";
	export type ElementType = HTMLElement;
	export type Props = Popover.Popup.Props;
}

export const PopoverPopup = (componentProps: PopoverPopup.Props) => {
	const { children, ...restProps } = componentProps;

	return <Popover.Popup {...restProps}>{children}</Popover.Popup>;
};
